import React from 'react';
import PropTypes from 'prop-types';

import {
  MdThumbUp,
  MdThumbUpOffAlt,
  MdThumbDown,
  MdThumbDownOffAlt,
} from 'react-icons/md';
import CommentList from '../comment/CommentList';
import CommentInput from '../../input/CommentInput';

import { showFormattedDate } from '../../../utils';
import { SettingConsumer } from '../../../contexts/settingContext';
import { CREATED_BY, CREATED_BY_EN } from '../../../utils/common/constant';
import {
  DetailPageTitle,
  DivDetailPageBody,
  DivDetailPageFooter,
  SectionThreadDetail,
  VoteThreadButton,
  ThreadItemCreatedAt,
  ParagraphCreated,
  SpanCircle,
  ImageAvatarComment,
} from '../../styled';

const ThreadDetailItem = ({
  comments,
  title,
  createdAt,
  body,
  downVotesBy,
  upVotesBy,
  onCreateComment,
  onUpVotesThread,
  onNeutralsVotesThread,
  onDownsVotesThread,
  authUser,
  owner,
}) => {
  const { name, avatar } = owner;
  const downVoteLength = downVotesBy.length;
  const upVoteLength = upVotesBy.length;
  const commentLength = comments.length.toString();

  const upVoted = upVotesBy.find((upVote) => upVote === authUser.id);
  const downVoted = downVotesBy.find((downVote) => downVote === authUser.id);

  return (
    <SettingConsumer>
      {
        ({ locale }) => {
          return (
            <SectionThreadDetail>
              <DetailPageTitle>{title}</DetailPageTitle>
              <DivDetailPageBody dangerouslySetInnerHTML={{ __html: body }} />
              <br />
              <DivDetailPageFooter>
                {upVoted !== undefined
                  ? <VoteThreadButton type="button" aria-label="up-votes" title="up-votes" onClick={onNeutralsVotesThread}><MdThumbUp className="thread-icon" /></VoteThreadButton>
                  : <VoteThreadButton type="button" aria-label="up-votes" title="up-votes" onClick={onUpVotesThread}><MdThumbUpOffAlt className="thread-icon" /></VoteThreadButton>}
                <ThreadItemCreatedAt>{upVoteLength}</ThreadItemCreatedAt>
                &nbsp;&nbsp;&nbsp;&nbsp;
                {downVoted !== undefined
                  ? <VoteThreadButton type="button" aria-label="down-votes" title="down-votes" onClick={onNeutralsVotesThread}><MdThumbDown className="thread-icon" /></VoteThreadButton>
                  : <VoteThreadButton type="button" aria-label="down-votes" title="down-votes" onClick={onDownsVotesThread}><MdThumbDownOffAlt className="thread-icon" /></VoteThreadButton>}
                <ThreadItemCreatedAt>{downVoteLength}</ThreadItemCreatedAt>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <ParagraphCreated>{showFormattedDate(createdAt)}</ParagraphCreated>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <SpanCircle>·</SpanCircle>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <ParagraphCreated>
                  {locale === 'id' ? CREATED_BY : CREATED_BY_EN}
                  &nbsp;&nbsp;
                  <ImageAvatarComment src={avatar} alt="Avatar" />
                  &nbsp;
                  {name}
                </ParagraphCreated>
              </DivDetailPageFooter>
              <br />
              <br />
              <CommentInput onCreateComment={onCreateComment} />
              <CommentList comments={comments} commentLength={commentLength} />
            </SectionThreadDetail>
          );
        }
      }
    </SettingConsumer>
  );
};

const userShape = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
};

const threadItemShape = {
  authUser: PropTypes.shape(userShape).isRequired,
  id: PropTypes.string,
  title: PropTypes.string,
  createdAt: PropTypes.string,
  body: PropTypes.string,
  archived: PropTypes.bool,
  upVotesBy: PropTypes.array,
  downVotesBy: PropTypes.array,
  comments: PropTypes.array,
  onUpVotesThread: PropTypes.func,
  onNeutralsVotesThread: PropTypes.func,
  onDownsVotesThread: PropTypes.func,
  owner: PropTypes.object,
};

ThreadDetailItem.defaultProps = {
  onCreateComment: null,
};

ThreadDetailItem.propTypes = {
  ...threadItemShape,
  onCreateComment: PropTypes.func,
};

export default ThreadDetailItem;
